import React from "react";
import {
  Button,
  PanelDialog,
  PanelHeading,
  PanelRow,
  PanelSpacer,
  PanelActions,
  BoldText,
} from "@backslashbuild/pp-ui";
import { usePost } from "./api";
import { publish } from "../../pubSub";
import { useHistory } from "react-router-dom";

function IgnoreWarningsPayslipButton({ id }) {
  const history = useHistory();

  // you have to query to see if there are any currently staged pay runs and then disable the button.
  const [dialogOpen, setDialogOpen] = React.useState(false);

  const updatePayslip = usePost("payslips/ignore-warnings");

  async function handleSubmit() {
    try {
      const response = await updatePayslip({ payslipId: id });

      if (response.isSuccess) {
        publish("notification", "Payslip updated. Warnings will now be ignored during Pay Run.");
      } else {
        publish(
          "notification",
          <>
            Unable to update payslip
            <ul>
              {response.errors.map((error) => (
                <li>{error}</li>
              ))}
            </ul>
          </>
        );
      }
    } catch (e) {
      console.error(e, "error updating payslip");
      publish("notification", "A network error occured.");
    }
  }

  return (
    <>
      <Button variant="secondary" large onClick={() => setDialogOpen(true)}>
        Ignore payslip warnings
      </Button>
      <PanelDialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <PanelHeading>Ignore Payslip Warnings</PanelHeading>
        <PanelSpacer large />
        <PanelRow>
          <BoldText>
            Are you sure you want to ignore all warnings?
            <br />
            Warnings will be ignored during Pay Run.
          </BoldText>
        </PanelRow>
        <PanelSpacer large />
        <PanelActions>
          <Button variant="secondary" onClick={() => setDialogOpen(false)}>
            No, Don't Ignore
          </Button>
          <Button onClick={handleSubmit}>Yes, Ignore Warnings</Button>
        </PanelActions>
        <PanelSpacer large />
      </PanelDialog>
    </>
  );
}

export default IgnoreWarningsPayslipButton;
